import type { ContratProDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'

export const getNaturesFichiersCpro: NaturesFichiersDemandeCallback<ContratProDTO> = (demande, typeContext) => {
  let obligatoires = new Set(['Cerfa'])
  let facultatifs = new Set(['Autre', 'ProtocoleIndividuelFormationFOAD'])
  let facultatifsDefaut: Set<string> = new Set([])

  const existsFormationInterne = demande.formation?.modules?.some((x) => x.typeModule === 'Interne')
  const nbModule = demande.formation?.modules?.length ?? 0
  const nbFormationExterne = demande.formation?.modules?.filter((x) => x.typeModule === 'Externe').length ?? 0

  switch (demande.sousDispositif) {
    case 'ContratProfessionnalisation': {
      if (nbFormationExterne) obligatoires.add('Convention')

      obligatoires.add('Programme')
      if (
        ['3043', '0573'].includes(demande.employeur!.etablissement!.idcc!.code) &&
        demande.formation?.typeQualification === 'Cqp'
      )
        obligatoires.add('ConventionBilanEvaluation')

      if (existsFormationInterne) {
        obligatoires.add('Calendrier')
        obligatoires.add('AttestationFormateurInterne')
      }
      break
    }
    case 'Prodiat': {
      if (nbFormationExterne > 1) obligatoires.add('Convention')
      obligatoires.add('ConventionEntrepriseOFA')

      if (existsFormationInterne) {
        obligatoires.add('AttestationFormateurInterne')
      }

      obligatoires.add('CVBeneficiaire')
      obligatoires.add('ExtraitClassificationCCNVisee')
      break
    }
  }

  if (typeContext === TypesContextesAutorisesEnum.Prestataire) {
    facultatifs = new Set([...obligatoires, ...facultatifs])
    facultatifsDefaut = new Set([...obligatoires, ...facultatifsDefaut])
    obligatoires = new Set([])
  }

  return {
    obligatoires: [...obligatoires],
    facultatifs: [...facultatifs],
    facultatifsDefaut: [...facultatifsDefaut],
    /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
        {
            'Cerfa': 10,
            'Convention': 2
        }
    */
    nombreFichiersMaximum: {},
    nombreFichiersMinimum: {
      Convention: nbFormationExterne,
      Programme: nbModule,
    },
  }
}
